<template lang="pug">
.smartlynq-configuration
  h1.title {{ $t('settings_tab.channels_tab.smartlynq_configuration.title') }}
  .form-container
    .sub-header--solid {{ $t('settings_tab.channels_tab.smartlynq_configuration.cors_title') }}
    .form__inner-content
      cors-configuration(:cors-config="smartlynqCorsConfig"
                         @update="onUpdateCors")
</template>

<script>
import CorsConfiguration from '../WebchatConfigurationTab/CorsConfiguration.vue';

export default {
  name: 'smartlynq-configuration-tab',
  components: {
    CorsConfiguration,
  },
  data() {
    return {
      smartlynqCorsConfig: null,
    };
  },
  async mounted() {
    try {
      const [
        smartlynqCorsConfig,
      ] = await Promise.all(
        [
          'smartlynq_cors_configuration',
        ].map(name => this.$store.dispatch('settings/getSetting', { name })),
      );

      this.smartlynqCorsConfig = smartlynqCorsConfig;
    } catch (err) {
      this.$aiq.notify.error(err.message);
    }
  },
  methods: {
    async onUpdateCors(newConfig) {
      try {
        this.smartlynqCorsConfig = await this.$store.dispatch('settings/updateSetting', {
          name: 'smartlynq_cors_configuration',
          payload: newConfig,
        });
        this.$aiq.notify.success('Updated');
      } catch (err) {
        this.$aiq.notify.error(err.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.smartlynq-configuration {
  .title {
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 18px;
  }
}
</style>
